import React from "react";
import styled, { ThemeProvider } from "styled-components";
import { Box, Flex } from "rebass";

import { H2, H3, H4, PageSection } from "components";
import invertTheme from "../../invertTheme";

const Avatar = styled(Box)`
  width: 128px;
  min-width: 128px;
  height: 128px;
  min-height: 128px;
  border-radius: 9999px;
  background: ${(props) => props.theme.colors.grey[1]};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: ${(props) => "url(" + props.image + ")"};
`;

const QuoteTicks = () => (
  <svg
    width="131"
    height="90"
    viewBox="0 0 131 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.7174 0H67.5L55.8478 90H0.5L26.7174 0Z"
      fill="#EBEBEB"
      fillOpacity="0.15"
    />
    <path
      d="M104.283 90L63.5 90L75.1522 2.79073e-06L130.5 7.62939e-06L104.283 90Z"
      fill="#EBEBEB"
      fillOpacity="0.15"
    />
  </svg>
);

const QuoteWrapper = styled(Box)`
  position: absolute;
  top: 0px;
  margin-top: -12px;
  left: 0px;
  margin-left: -32px;
`;

export const Quote = (props) => {
  return (
    <ThemeProvider theme={invertTheme}>
      <PageSection>
        <Box bg="ash" py={3}>
          <Flex
            flexDirection={["column", null, "row"]}
            borderTop="1px solid"
            borderColor="grey.0"
            py={[4, 5, 6]}
          >
            {props.primary.headshot &&
              props.primary.headshot.quarter &&
              props.primary.headshot.quarter.url && (
                <Box mr={[0, 7, 8]} mb={[6, 0, 0]}>
                  <Avatar image={props.primary.headshot.quarter.url} />
                </Box>
              )}
            <Box style={{ position: "relative" }}>
              <QuoteWrapper>
                <QuoteTicks />
              </QuoteWrapper>
              {props.primary.quote && <H2 mb={4}>{props.primary.quote}</H2>}
              {props.primary.author && <H3 mb={1}>{props.primary.author}</H3>}
              {props.primary.role && <H4>{props.primary.role}</H4>}
            </Box>
          </Flex>
        </Box>
      </PageSection>
    </ThemeProvider>
  );
};



// WEBPACK FOOTER //
// ./src/slices/Quote/Quote.js